import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5),
    },
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  filter: {
    borderRadius: 10,
  },
  card: {
    borderRadius: 14,
    border: "1px solid #e8edf3",
    background: "#ffffff",
    overflow: "hidden",
  },
  headRow: {
    display: "flex",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    background: "#f8fafc",
  },
  row: {
    display: "flex",
    gap: theme.spacing(2),
    padding: theme.spacing(1.75, 2),
    borderTop: "1px solid #f1f5f9",
  },
  cell: {
    flex: 1,
    minWidth: 0,
  },
}));

// Page-level placeholder for table/list screens: a filter toolbar plus a table
// card of `rows` × `columns` cells, so the loading state keeps the same shape
// as the content that replaces it.
const ListPageSkeleton = ({ rows = 6, columns = 5, showToolbar = true }) => {
  const classes = useStyles();

  return (
    <div className={classes.root} role="status" aria-label="Loading page content">
      {showToolbar && (
        <div className={classes.toolbar} aria-hidden="true">
          <Skeleton variant="rect" width={170} height={44} className={classes.filter} animation="wave" />
          <Skeleton variant="rect" width={170} height={44} className={classes.filter} animation="wave" />
          <Skeleton variant="rect" width={120} height={44} className={classes.filter} animation="wave" />
          <Skeleton variant="rect" width={110} height={44} className={classes.filter} animation="wave" />
        </div>
      )}

      <div className={classes.card} aria-hidden="true">
        <div className={classes.headRow}>
          {Array.from({ length: columns }).map((_, i) => (
            <div key={i} className={classes.cell}>
              <Skeleton variant="text" width="70%" height={20} animation="wave" />
            </div>
          ))}
        </div>

        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className={classes.row}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div key={colIndex} className={classes.cell}>
                <Skeleton variant="text" height={22} animation="wave" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListPageSkeleton;
